export const version = "networks/5.5.2";
//# sourceMappingURL=_version.js.map